const getDefaultState = () => {
  return {
    filters: {},
    billingFilters: {
      power_plant_id: "",
      competence: "",
      status: "",
    },
    itemsFilter: {},
    loading: false,
    totalBillings: [],
    loadingTotalBillings: false,
    billings: [],
    items: [],
    billingItems: [],
    itemsComplete: [],
    totalItems: 0,
    lastItem: null,
    loadingBillings: false,
    totalBilling: {},
    dialog_details: false,
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 100,
      sortBy: "name",
      totalItems: 0,
      rowsPerPageItems: [5, 10, 25, 50, 100],
    },
    statusList: [],
    bankBatchs: [],
    loadingBankBatchs: false,
    bankBatchsUsinas: [],
    loadingBankBatchsUsinas: false,
    billetsBankBatch: [],
  };
};

// initial state
const state = getDefaultState();

export default {
  getDefaultState,
  ...state,
};
